var _path, _mask, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralActionMoreVertical = function SvgGeneralActionMoreVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    d: "M12 10.496c.828 0 1.5.673 1.5 1.504s-.672 1.505-1.5 1.505-1.5-.674-1.5-1.505.672-1.504 1.5-1.504"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "general-action-more-vertical_svg__a",
    width: 4,
    height: 4,
    x: 10,
    y: 17,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.5 17.991h3V21h-3z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#general-action-more-vertical_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    d: "M12 17.991c.828 0 1.5.674 1.5 1.505S12.828 21 12 21s-1.5-.673-1.5-1.504.672-1.505 1.5-1.505"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    d: "M12 3c.828 0 1.5.674 1.5 1.505s-.672 1.504-1.5 1.504-1.5-.674-1.5-1.505S11.172 3 12 3"
  })));
};
export default SvgGeneralActionMoreVertical;